import http from "@/settings/apiSettings";

class CrmTipuriActivitatiDataService {
  
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_CautareTipuriActivitati", data);
  }
saveEdit(id: string, data: any): Promise<any> {
    return http.clientComercialOdata.put(`/CRM_TipuriActivitati(${id})`, data);
  }
 
}

export default new CrmTipuriActivitatiDataService();
